// @flow

import * as ACTIONS from '../constants/actions';
import { aiChat } from '../services/api';

export const fetchChatThreads = () => async (dispatch: Function) => {
  try {
    dispatch({ type: ACTIONS.FETCH_CHAT_THREADS_REQUEST });
    const response = await aiChat.getThreads();
    dispatch({
      type: ACTIONS.FETCH_CHAT_THREADS_SUCCESS,
      payload: { threads: response.threads || [] },
    });
  } catch (error) {
    console.error('Error fetching chat threads:', error);
    dispatch({ type: ACTIONS.FETCH_CHAT_THREADS_ERROR });
    // Silent fail - don't show toast for thread list fetch errors
  }
};

export const clearChatThreads = () => ({
  type: ACTIONS.CLEAR_CHAT_THREADS,
});

export const updateChatThread =
  (threadId: string, payload: { title?: string, pinned?: boolean }) =>
  async (dispatch: Function) => {
    const thread = await aiChat.updateThread(threadId, payload);
    dispatch({ type: ACTIONS.UPDATE_CHAT_THREAD_SUCCESS, payload: { thread } });
    return thread;
  };

export const deleteChatThread =
  (threadId: string) => async (dispatch: Function) => {
    try {
      await aiChat.deleteThread(threadId);
    } catch (error) {
      const status = error && error.response && error.response.status;
      // Already gone server-side — treat as success (same as the page flow).
      if (status !== 404) throw error;
    }
    await dispatch(fetchChatThreads());
  };

export const refreshThreadsForTitle =
  (threadId: string) => async (dispatch: Function, getState: Function) => {
    await dispatch(fetchChatThreads());
    const hasTitle = () => {
      const threads = (getState().chatThreads || {}).threads || [];
      const match = threads.find((t) => t && t.id === threadId);
      return !!(match && match.title);
    };
    if (hasTitle()) return;
    // Title generation can lag the stream close slightly (see API doc §4) — one retry.
    await new Promise((resolve) => setTimeout(resolve, 2000));
    await dispatch(fetchChatThreads());
  };
